"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddCustomerOrderErrorResponse = exports.Name = exports.AddCustomerOrderFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-customer-order-failed';
const AddCustomerOrderFailedEvent = exports.AddCustomerOrderFailedEvent = Name;
const isAddCustomerOrderErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddCustomerOrderErrorResponse = isAddCustomerOrderErrorResponse;
